/**
 * Mensagem segura para exibir ao usuário a partir de um erro Axios/API.
 * Prefere `response.data.error` / `response.data.message`.
 * Não devolve `error.message` técnico (ex.: "Network Error").
 */
export const getApiErrorMessage = (error, fallback) => {
  const data = error?.response?.data;

  if (typeof data === 'string' && data.trim()) {
    return data.trim();
  }

  const responseMessage = data?.error || data?.message;
  return typeof responseMessage === 'string' && responseMessage.trim()
    ? responseMessage.trim()
    : fallback;
};

/**
 * Quando o axios espera blob e a API devolve JSON de erro em Blob.
 */
export const getApiBlobErrorMessage = async (
  error,
  fallback = 'Não foi possível concluir a ação.',
) => {
  const responseData = error?.response?.data;

  if (!(responseData instanceof Blob)) {
    return getApiErrorMessage(error, fallback);
  }

  const text = await responseData.text().catch(() => '');
  if (!text) return fallback;

  try {
    const parsed = JSON.parse(text);
    const message = parsed?.error || parsed?.message;
    return typeof message === 'string' && message.trim() ? message.trim() : fallback;
  } catch {
    return text.trim() || fallback;
  }
};

export default getApiErrorMessage;
